import React from "react";
import ItemsSlider from "theme/components/organisms/ItemsSlider/ItemsSlider";
import ProductItemSkeleton from "theme/modules/ProductView/ProductItem/ProductItemSkeleton";
import { useSliderState } from "theme/components/organisms/Slider/Slider";
import withNumberOfProductsPerSlide from "./withNumberOfProductsPerSlide";

const ProductListSliderSkeleton = ({ numberOfProductsPerSlide }) => {
  const sliderProps = useSliderState(numberOfProductsPerSlide);
  return (
    <ItemsSlider
      sliderProps={sliderProps}
      itemsPerSlide={numberOfProductsPerSlide}
    >
      {new Array(numberOfProductsPerSlide).fill(null).map((_, index) => {
        return <ProductItemSkeleton key={`empty-${index}`} />;
      })}
    </ItemsSlider>
  );
};

export default withNumberOfProductsPerSlide()(ProductListSliderSkeleton);
